// extracted by css-extract-rspack-plugin
export default {"wrapper":"_fda05fa","title":"_647f32a9","description":"_d216ae8f"};